import DeviceDetector from "device-detector-js";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Navigate, useParams } from "react-router-dom";
import { APP_CONST } from "../../../../config/const";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { socket, socketFunc } from "../../../../utils/socketUtil";
import { Toaster } from "../../../../utils/toaster";
import ExchangeFundsForm from "../../../components/ExchangeFundsForm";
import { axiosService } from "../../../../utils/axiosService";
import BottomNav from "../../../../containers/BottomNav";

const ExchangeLobbyPage = () => {
  const [casinoLobbyUrl, setCasinoLobbyUrl] = useState();
  let { gameId } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    const deviceDetector = new DeviceDetector();
    const userAgent = window.navigator.userAgent;
    const device = deviceDetector.parse(userAgent);
    // console.log({ mobile: device?.device?.type === "smartphone" });
    socketFunc(token).emit(
      "get:jetfair_lobby",
      {
        mobile: device?.device?.type === "smartphone",
        sportName: gameId,
      },
      (res) => {
        console.log("res", res);
        if (res?.status === "failed") {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, res.message);

          return setCasinoLobbyUrl("notAllowed");
        }
        if (res?.status === "success" && res?.data?.errorCode) {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, res?.data?.message);

          return setCasinoLobbyUrl("notAllowed");
        }
        setCasinoLobbyUrl(res?.data?.data?.lobbyUrl || "notFound");
      }
    );

    return () => {
      socket.off("get:jetfair_lobby");
    };
  }, [gameId]);

  return (
    <>
      <div className="header-bg">
        <HeaderAfterLogin />
      </div>

      <div className="live_casino_page live">
        {!Boolean(casinoLobbyUrl) ? (
          <div className="custom_placeholder_parent">
            <div className="custom_placeholder_child">
              <Spinner animation="grow" variant="primary" size="sm" />
              <Spinner animation="grow" variant="primary" size="sm" />
              <Spinner animation="grow" variant="primary" size="sm" />
            </div>
          </div>
        ) : casinoLobbyUrl === "notAllowed" ? (
          <Navigate to="/home" />
        ) : casinoLobbyUrl === "notFound" ? (
          <Navigate to="/home" />
        ) : (
          <div className="exchange_iframe">
            <iframe
              title="Exchange"
              src={casinoLobbyUrl}
              frameBorder="0"
              style={{
                width: "100%",
                height: "calc(100vh - 130px)",
              }}
              // scrolling="no"
              allowFullScreen={true}
            >
              Your browser doesn't support iFrames.
            </iframe>
          </div>
        )}
        {/*  Iframe End */}
      </div>

      {/* <BottomNav /> */}
    </>
  );
};

export default ExchangeLobbyPage;
